// Component: Button.jsx
// Purpose: DS Button primitive — a thin wrapper over the ds-components.css `.btn`
//          classes. Maps variant/size props to classNames; supports `as` (render
//          as a router Link / <a>), icon-only, and ref forwarding. No styling
//          lives here — the look comes from the token-backed DS CSS.

import React, { forwardRef } from "react";
import { cx } from "./cx";

// --> variant → DS class. Mirrors preview/buttons.html + ds-components.css.
const VARIANTS = {
  primary: "btn-primary",
  secondary: "btn-secondary",
  ghost: "btn-ghost",
  danger: "btn-danger",
  accent: "btn-accent",
  "commit-buy": "btn-commit-buy",
  "commit-sell": "btn-commit-sell",
};

const SIZES = { sm: "btn-sm", md: "", lg: "btn-lg" };

export const Button = forwardRef(function Button(
  {
    as: As = "button",
    variant = "primary",
    size = "md",
    iconOnly = false,
    type,
    className,
    ...props
  },
  ref
) {
  const cls = cx(
    "btn",
    VARIANTS[variant] || VARIANTS.primary,
    SIZES[size],
    iconOnly && "btn-icon",
    className
  );
  //! Only a native <button> gets a default type (avoid invalid `type` on <a>).
  const nativeProps = As === "button" ? { type: type || "button" } : {};
  return <As ref={ref} className={cls} {...nativeProps} {...props} />;
});

export default Button;
